import { HEADER_STYLES } from "../../../enums/HeaderStyles";

const dropDownColumns = ["U_name", "U_countAsWorkingTime", "U_reason"];
const rangeColumns = ["U_date", "U_openVacation", "U_usedVacation", "U_totalVacation", "U_factor", "U_memberCount"];

const searchColumns = ["teams"];

export default [
  ...rangeColumns.map((column) => ({
    column,
    value: HEADER_STYLES.RANGE
  })),
  ...dropDownColumns.map((column) => ({
    column,
    value: HEADER_STYLES.DROPDOWN
  })),
  ...searchColumns.map((column) => ({
    column,
    value: HEADER_STYLES.SEARCH
  }))
];
